import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Import das imagens
import corte from "../../assets/images/corte.jpeg";
import perfis from "../../assets/images/perfis.jpg";
import acessorios from "../../assets/images/acessorios.jpg";
import chapas from "../../assets/images/chapas.jpg";
import algerosa from "../../assets/images/algerosa.jpg";
import dobras from "../../assets/images/dobra.jpg";
import laminados from "../../assets/images/laminados.jpg";
import projetos from "../../assets/images/projetos_especiais.jpg";
import telhas from "../../assets/images/telhas.jpg";
import tubos from "../../assets/images/tubos.jpg";

const Servicos = () => {
  const servicos = [
    {
      img: corte,
      titulo: "Corte sob medida",
      texto:
        "Precisão e tecnologia no corte de chapas e perfis em aço, garantindo encaixe perfeito e redução de desperdícios.",
    },
    {
      img: perfis,
      titulo: "Perfis estruturais",
      texto:
        "Perfis laminados e soldados que asseguram resistência, estabilidade e desempenho estrutural em qualquer aplicação.",
    },
    {
      img: acessorios,
      titulo: "Acessórios",
      texto:
        "Linha completa de acessórios em aço e inox, com acabamento superior e durabilidade para complementar cada projeto.",
    },
    {
      img: chapas,
      titulo: "Chapas e bobinas",
      texto:
        "Variedade em chapas e bobinas de aço carbono, galvanizado e inox, ideais para aplicações industriais e construtivas.",
    },
    {
      img: algerosa,
      titulo: "Calhas e Algerosas",
      texto:
        "Soluções completas em calhas e algerosas, desenvolvidas para eficiência no escoamento e proteção de estruturas.",
    },
    {
      img: dobras,
      titulo: "Dobras",
      texto:
        "Serviço de dobra de chapas com alta precisão e controle dimensional, atendendo às exigências técnicas de cada projeto.",
    },
    {
      img: laminados,
      titulo: "Laminados",
      texto:
        "Produtos laminados em aço de alto desempenho, com superfície uniforme e resistência ideal para estruturas e acabamentos.",
    },
    {
      img: projetos,
      titulo: "Projetos Especiais",
      texto:
        "Desenvolvimento de soluções personalizadas em aço, adaptadas às necessidades técnicas e arquitetônicas de cada cliente.",
    },
    {
      img: telhas,
      titulo: "Telhas",
      texto:
        "Telhas metálicas em aço galvanizado e inox, unindo estética, durabilidade e proteção contra intempéries.",
    },
    {
      img: tubos,
      titulo: "Tubos",
      texto:
        "Tubos em aço carbono e inox para aplicações estruturais e industriais, combinando resistência, precisão e acabamento de alto padrão.",
    },
  ];

  return (
    <section id="services" className="servicos-section">
      <h2 className="servicos-title">Nossos Produtos e Serviços</h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        spaceBetween={30}
        slidesPerView={3}
        slidesPerGroup={1}
        centeredSlides={false}
        loop={false}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="servicos-swiper"
      >
        {servicos.map((item, index) => (
          <SwiperSlide key={index} className="servico-card">
            <div className="servico-card-content">
              <img src={item.img} alt={item.titulo} className="servico-img" />
              <h3>{item.titulo}</h3>
              <p>{item.texto}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Servicos;
